import React, { useEffect, useRef, useState } from 'react';
import "./homepageobject2.css";
import { VscFeedback } from 'react-icons/vsc';
import { useLanguage } from '../../context/LanguageContext';

const HomePageObject2 = () => {
  const { t, changeLanguage } = useLanguage();
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`home-object2-container text-left ${isVisible ? 'fade-in' : ''}`} ref={ref}>
      <div className='flex items-center object2-header'>
        <span className='home-object2-head-title'>{t("homeobject2-headtitle")}</span>
        <hr className='homepage-hr' />
      </div>
      <h1 className='homepage-card2-title2'>

      </h1>
      <div className='card2-container md:grid grid-cols-3 gap-4 mt-8'>
        <div className='homepage-card2 flex'>
          <div className='homepage-card2-number'>1</div>
          <div className='homepage-card2-container'>
            <h4 className='homepage-card2-title3'>{t("homeobject2-title1")}</h4>
            <p className='homepage-card2-text'>{t("homeobject2-text1")}</p>
          </div>
        </div>
        <div className='homepage-card2 flex'>
          <div className='homepage-card2-number'>2</div>
          <div className='homepage-card2-container'>
            <h4 className='homepage-card2-title3'>{t("homeobject2-title2")}</h4>
            <p className='homepage-card2-text'>{t("homeobject2-text2")}</p>
          </div>
        </div>
        <div className='homepage-card2 flex'>
          <div className='homepage-card2-number'>3</div>
          <div className='homepage-card2-container'>
            <h4 className='homepage-card2-title3'>{t("homeobject2-title3")}</h4>
            <p className='homepage-card2-text'>{t("homeobject2-text3")}</p>
          </div>
        </div>
      </div>


      <div className='card2-container md:grid grid-cols-3 gap-4 mt-8'>
        <div className='homepage-card2 flex'>
          <div className='homepage-card2-number'>4</div>
          <div className='homepage-card2-container'>
            <h4 className='homepage-card2-title3'>{t("homeobject2-title4")}</h4>
            <p className='homepage-card2-text'>{t("homeobject2-text4")}</p>
          </div>
        </div>
        <div className='homepage-card2 flex'>
          <div className='homepage-card2-number'>5</div>
          <div className='homepage-card2-container'>
            <h4 className='homepage-card2-title3'>{t("homeobject2-title5")}</h4>
            <p className='homepage-card2-text'>{t("homeobject2-text5")}</p>
          </div>
        </div>
        <div className='homepage-card2 flex'>
          <div className='homepage-card2-number'>6</div>
          <div className='homepage-card2-container'>
            <h4 className='homepage-card2-title3'>{t("homeobject2-title6")}</h4>
            <p className='homepage-card2-text'>{t("homeobject2-text6")}</p>
          </div>
        </div>
      </div>


    </div>
  );
};

export default HomePageObject2;
